import { Input, Label, cn } from '@consigli/shadcn';

interface DateRangeFilterProps {
  from: string;
  to: string;
  onFromChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onToChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  minDate?: string;
  maxDate?: string;
  className?: string;
}

export const DateRangeFilter = ({
  from,
  to,
  onFromChange,
  onToChange,
  minDate,
  maxDate,
  className,
}: DateRangeFilterProps) => {
  return (
    <div className={cn('flex gap-4 items-end', className)}>
      <div className="flex flex-row items-center gap-1.5">
        <Label htmlFor="date-from">From</Label>
        <Input
          id="date-from"
          type="date"
          value={from}
          min={minDate}
          max={maxDate}
          onChange={onFromChange}
          className="w-[160px]"
        />
      </div>
      <div className="flex flex-row items-center gap-1.5">
        <Label htmlFor="date-to">To</Label>
        <Input
          id="date-to"
          type="date"
          value={to}
          min={minDate}
          max={maxDate}
          onChange={onToChange}
          className="w-[160px]"
        />
      </div>
    </div>
  );
};
